import React, {useEffect, useState} from 'react';
import "../../main/main.css";
import Translate from "localization/Translate";
import Button from "../../buttons/Button";
import {useDispatch, useSelector} from "react-redux";
import API, {addPenniesItem, getStoreID} from "./Api";
import {getProductsTotalSum} from "../../redux/selectors";
import {
    setPenniesDonation
} from "../../redux/actions";
import {Loader} from "../../main/Loading";
import {PerfectScrollbarWithHotfix as PerfectScrollbar} from "../../uiComponents/WrappedPerfectScrollBar";

const CharityImage = ({src, alt}) => {
    return <div style={{
        width: "50%",
        height: "100%",
        display: "flex",
        alignItems: "center"
    }}>
        <img style={{
            height: "100%",
            maxHeight: "10.71rem",
            maxWidth: "10.71rem",
            margin: "0 auto"
        }} src={src}  alt={alt}/>
    </div>
}

const addDonationProduct = (dispatch, donationAmount, state, charity) => {
    let thankYouShown = false;
    let donationProductAdded = false;
    setTimeout(() => {
        thankYouShown = true;
        if(donationProductAdded){
            dispatch(setPenniesDonation(true, donationAmount, charity));
        }
    }, 2000);
    addPenniesItem(dispatch, state, donationAmount).then(() => {
        donationProductAdded = true;
        if(thankYouShown){
            dispatch(setPenniesDonation(true, donationAmount, charity));
        }
    }, () => {});
}

const getDonationAmountsFromCalculation = (response) => {
    let amounts = [response.donation_amount, ...(response?.additional_donation_amounts ?? [])];
    return amounts.filter(el => parseFloat(el) !== 0);
}

const AskDonation = () => {
    let state = useSelector(state => state);
    let storeID = getStoreID(state);
    let cashierMode = state.rootReducer.cashierMode;
    let basketTotal = getProductsTotalSum(state.rootReducer.productsInBasket);
    let dispatch = useDispatch();
    let [donationAmounts, setDonationAmounts] = useState([]);
    let [charity, setCharity] = useState({});
    let [donationSet, setDonation] = useState(false);

    useEffect(() => {
        if(cashierMode){
            dispatch(setPenniesDonation(true, false));
        }else{
            API.calculation(basketTotal, storeID, state).then((response) => {
                if(typeof response?.charities?.[0] !== "undefined"){
                    let calculatedDonationAmounts = getDonationAmountsFromCalculation(response);
                    if(calculatedDonationAmounts.length > 0){
                        setDonationAmounts(calculatedDonationAmounts);
                        setCharity(response.charities[0]);
                    }else{
                        dispatch(setPenniesDonation(true, false));
                    }
                }else{
                    dispatch(setPenniesDonation(true, false));
                }
            },(response) => {
                console.log("Pennies: API.calculation failed", {response});
                dispatch(setPenniesDonation(true, false));
            })
        }
        return () => {}
    }, []);

    if(typeof charity.heading === "undefined"){
        return <Loader position={"absolute"}/>
    }

    let paymentButton = (
        <div style={{margin: "1rem 0"}} onClick={e => {
            dispatch(setPenniesDonation(true, donationSet));
        }}>
            <Button
                buttonStyle={{minWidth: "21.43rem"}}
                type="button"
                className={"largeButton yellowButton"}
                name={<Translate id="Proceed"/>}
            />
        </div>
    );
    let CheckMark = ({checked}) => {
        return (
            <i className={"icoFont"} style={{
                color: checked ? "#3642b9" : "#fff",
                backgroundColor: "#fff",
                borderRadius: "1.43rem",
                fontSize: '1.43rem',
                padding: "0.142857rem",
                border: "0.07rem solid #ccc"
            }}>&#xeed6;</i>
        );
    }
    let DonationButton = ({onClick, amount, donate=true}) => {
        let currency = useSelector((state) => state.rootReducer.currency);
        return <div style={{
            flexGrow: 1,
            textAlign: "center"
        }} onClick={onClick}>
            <button
                type="button"
                className={"button"}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.57rem",
                    overflow: "hidden",
                    width: "100%",
                    minWidth: "10rem",
                    fontSize: '1.29rem',
                    border: "0.07rem solid #e1e0df",
                    backgroundColor: donate ? "#fff" : "#3642b9",
                    color: donate ? "#3642b9" : "#fff",
                    padding: "1.43rem 0.29rem",
                    marginTop: "0.71rem",
                    textTransform: "initial"
                }}
            >
                <CheckMark checked={!donate}/>
                {donate ?
                <Translate id={`Yes, donate ${currency}${amount}`} values={{currency, amount}}/> :
                <Translate id={'No thanks'}/>}
            </button>
        </div>
    };

    if(cashierMode){
        return <></>;
    }

    let charityName = charity?.name ?? "charity";
    let headingMessage = (charity?.heading ?? "Would you like to give [donation_amount] to support ${charityName}?").trim().replace("[donation_amount]","${value}");

    let content;
    if(donationSet){
        content = <>
            <div style={{
                whiteSpace: "pre-wrap",
                marginBottom: "0.36rem",
                fontSize: '1.71rem',
                minHeight: 200,
                textAlign: "center",
                marginTop: 54
            }} className={"boldUppercaseText"}>
                <Translate id={charity?.thank_you_message ?? "Thank you for the donation"}/>
            </div>
        </>
    }else{
        content = <>
            <div style={{
                whiteSpace: "pre-wrap",
                marginBottom: "0.36rem",
                fontSize: '1.71rem'
            }} className={"boldUppercaseText"}>
                <Translate id={headingMessage} values={{value: donationAmounts[0], charityName}}/>
            </div>
            <div style={{
                fontSize: "1.14rem",
                width: "100%",
                margin: "0.71rem auto"
            }}>
                <Translate id={(charity?.soundbite_message ?? "Your micro-donation will help make a difference by providing expert support, funding and care for people most in need").trim()}/>
            </div>
            <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "0.71rem"
            }}>
                {donationAmounts.map((amount, index) => <DonationButton key={index} amount={amount} onClick={() => {
                    setDonation(amount);
                    addDonationProduct(dispatch, amount, state, charity);
                }}/>)}
                <DonationButton donate={false} onClick={() => {
                    dispatch(setPenniesDonation(true, donationSet));
                }}/>
            </div>
            <div style={{
                fontSize: "0.93rem",
                color: "#969696",
                borderTop: "0.07rem solid #ebeae8",
                width: "100%",
                margin: "1.43rem auto 1.43rem",
                paddingTop: "0.71rem"
            }}>
                <Translate id={(charity?.solicitation_message ?? "Every penny you give goes to charity").trim()}/>
            </div>
        </>;
    }

    return (
        <div style={{
            backgroundColor: "#edecea",
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            inset: 0
        }}>
            <div style={{
                flex: 1,
                overflow: "hidden",
                backgroundColor: "#fff",
                borderRadius: "2.14rem",
                margin: "2.14rem"
            }}>
            <PerfectScrollbar
                style={{
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <div style={{
                    padding: "1.43rem 2.86rem 0",
                    textAlign: "left"
                }}>
                    {content}
                </div>
                <div style={{
                    display: "flex",
                    flexGrow: 1,
                    minHeight: 100
                }}>
                    <CharityImage
                        src={charity?.charity_logo_url ?? ""}
                        alt={charityName}
                    />
                    <CharityImage
                        src={charity?.pennies_logo_url ?? ""}
                        alt={"pennies"}
                    />
                </div>
            </PerfectScrollbar>
            </div>
            {paymentButton}
        </div>
    );
}

export default AskDonation;